import { FALLBACK_ICON_KEY } from "./category_icons";
import { logger } from "./utils/logger";

const IMAGE_LOAD_RETRY_COUNT = 1;

function fetchImage(map, url) {
  return new Promise((resolve, reject) => {
    map.loadImage(url, (error, image) => {
      if (error) return reject(error);
      resolve(image);
    });
  });
}

async function fetchImageWithRetry(map, url, retryCount = IMAGE_LOAD_RETRY_COUNT) {
  let lastError;
  for (let attempt = 0; attempt <= retryCount; attempt += 1) {
    try {
      return await fetchImage(map, url);
    } catch (error) {
      lastError = error;
    }
  }
  throw lastError;
}

function groupNamesByUrl(icons) {
  return Object.entries(icons).reduce((result, [name, url]) => {
    if (!url) return result;
    (result[url] ||= []).push(name);
    return result;
  }, {});
}

// 同じURLの画像は1回だけ取得し、失敗してもレイヤー初期化を止めない
// （画像がないアイコンは icon-image の coalesce でフォールバックに解決される）
export async function loadIconImages(map, icons) {
  const namesByUrl = groupNamesByUrl(icons);

  await Promise.all(
    Object.entries(namesByUrl).map(async ([url, names]) => {
      const pendingNames = names.filter((name) => !map.hasImage(name));
      if (pendingNames.length === 0) return;

      try {
        const image = await fetchImageWithRetry(map, url);
        pendingNames.forEach((name) => {
          if (!map.hasImage(name)) map.addImage(name, image);
        });
      } catch (error) {
        logger.warn(`アイコン画像の読み込みに失敗しました: ${url}`, error);
      }
    })
  );
}

export async function initializeSpotsLayer({
  map,
  tilesetId,
  sourceLayer,
  icons,
  filter,
  onSymbolClick
}) {
  if (!tilesetId || !sourceLayer) return;

  map.addSource("spots", {
    type: "vector",
    url: `mapbox://${tilesetId}`
  });

  await loadIconImages(map, icons);

  map.addLayer({
    id: "spots-symbol",
    type: "symbol",
    source: "spots",
    "source-layer": sourceLayer,
    filter,
    layout: {
      "icon-image": [
        "coalesce",
        ["image", ["to-string", ["get", "primeCategoryId"]]],
        ["image", FALLBACK_ICON_KEY]
      ],
      "icon-size": 0.9,
      "icon-allow-overlap": true
    }
  });

  map.on("click", "spots-symbol", onSymbolClick);
  map.on("mouseenter", "spots-symbol", () => {
    map.getCanvas().style.cursor = "pointer";
  });
  map.on("mouseleave", "spots-symbol", () => {
    map.getCanvas().style.cursor = "";
  });
}
